import { encode as base64_encode } from 'base-64';
import { postApi,baseURL } from '../components/Utility'
import {
    action,
    makeObservable,
    observable
} from 'mobx';
import { message } from "antd";
import config from "../config";

class TempReportStore {
    total=0
    tempReportStore = []
    rootStore
    loading=false

    constructor(rootStore) {
        makeObservable(this, {
            total:observable,
            tempReportStore: observable,
            loadData: action,
            loading:observable

        });
        this.rootStore = rootStore;

    }



    async loadData({companyId,vehicleId,offset,limit,fromDate,toDate,pageNo}) {
      // console.log(pageNo)
       this.loading=true
        // console.log("vehicle list")
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "temp1min": "", "temp1max": "", "temp2min": "", "temp2max": "", "temp3min": "", "temp3max": "", "intervel": 5, "fromDate": fromDate, "showFlag": 0, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo, filter :"All Data" }
        
        if(config.pythonReport === 1){
              var response = await postApi.getClient('report').post("/report/trackData", postData);
              this.tempReportStore = response?.data?.data?.completereport
        }else{
              const base64Input = await base64_encode(JSON.stringify(postData));
              response = await postApi.getClient().post("index.php?c=vehicle&a=temprep", "postData=" + base64Input);
              this.tempReportStore = response?.data?.data?.temprep
        }

        // console.log(response?.data?.data)
        
        this.total=parseInt(response?.data?.data?.TotalCount)
        this.loading=false

    }
 
    async exportExcel(getData) {
        // console.log("getData", getData);
        if(config.pythonReport === 1){    
          try {
              var response = await postApi.getClient("report").post("/report/tempReport/download/excel", getData, {
                  responseType: "blob",
              });
          
              const blob = new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
          
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "Temperature Report.xlsx";
          
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
        
          } catch (error) {
              message.error("Failed to download the report. Please try again.")
          }
    
        }else{
            let lang = "english";
            window.location.href =
              baseURL +
              "index.php?c=vehicle&a=exporttempexcel&cid=" +
              getData.companyId +
              "&userId=" +
              getData.userId+
              "&vid=" +
              getData.vehicleId +
              "&int=" +
            5 +
              "&t1max" +
              " "+
              "&t1min" +
              " "+
              "&t2min" +
              " "+
              "&t2max" +
              " "+
              "&t3min" +
              " "+
              "&t3max" +
              " "+

              "&fD=" +
              getData.fromDate +
              "&tD=" +
              getData.toDate +
              "&colList=" +
              getData.colList +
              ",&language=" +
              lang;
        }
      }

      async exportpdf(getData) {

          if(config.pythonReport === 1){    
              try {
        
                var response = await postApi.getClient("report").post("/report/tempReport/download/pdf", getData, {
                    responseType: "blob",
                });
            
                const blob = new Blob([response.data], {
                    type: 'application/pdf'
                });
            
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "Temperature Report.pdf";
            
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              
              } catch (error) {
                  message.error("Failed to download the report. Please try again.")
              }
        
          }else{
              let lang = "english";
              window.location.href =
                baseURL +
                "index.php?c=vehicle&a=exportcrTempPdf&cid=" +
                getData.companyId +
                "&userId=" +
                getData.userId+
                "&vid=" +
                getData.vehicleId +
                "&int=" +
              5 +
                "&t1max" +
                " "+
                "&t1min" +
                " "+
                "&t2min" +
                " "+
                "&t2max" +
                " "+
                "&t3min" +
                " "+
                "&t3max" +
                " "+

                "&fD=" +
                getData.fromDate +
                "&tD=" +
                getData.toDate +
                "&colList=" +
                getData.colList ;
          }
      }
      async exportcsv(getData) {
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exporttempcsv&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId+
          "&vid=" +
          getData.vehicleId +
          "&int=" +
         5 +
          "&t1max" +
          " "+
          "&t1min" +
          " "+
          "&t2min" +
          " "+
          "&t2max" +
          " "+
          "&t3min" +
          " "+
          "&t3max" +
          " "+

          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList ;
        //   "&language=" +
        //   lang;
      }
      async exportxml(getData) {
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exporttempxml&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId+
          "&vid=" +
          getData.vehicleId +
          "&int=" +
         5 +
          "&t1max" +
          " "+
          "&t1min" +
          " "+
          "&t2min" +
          " "+
          "&t2max" +
          " "+
          "&t3min" +
          " "+
          "&t3max" +
          " "+

          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList ;
      }

}

export default TempReportStore;
